import Component from '../site/Component';

/**
 * Component for Countdown Clock module.
 */
export default class CountdownClock extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    // see if there is a clock module on the page.
    const clockContainer = document.querySelector(this.elements.clock);
    if (clockContainer) {
      this.countDown();
    }
  }

  countDown() {
    this.clockBox = document.getElementById('countdown-clock');
    if (this.clockBox) {
      let dateStg = this.clockBox.dataset.date;
      // Format string for Safari and IE, only replace first two spaces.
      dateStg = dateStg.replace(/,/g, '');
      dateStg = dateStg.replace(' ', '/').replace(' ', '/');
      const theDate = new Date(dateStg);
      // Update every second
      const x = setInterval(() => {
        const now = new Date().getTime();
        const distance = theDate - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours =
      Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const clockInner = document.createTextNode(`${days}d :
        ${hours}h : ${minutes}m : ${seconds}s`);
        const clockText = document.createElement('P');
        clockText.appendChild(clockInner);
        this.clockBox.appendChild(clockText);
        if (this.clockBox.children.length > 0) {
          this.clockBox.removeChild(this.clockBox.children[0]);
          this.clockBox.appendChild(clockText);
        }

        if (0 > distance) {
          clearInterval(x);
        }
      }, 1000);
    }
  }
}
